'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'type', 'ModalService', '$security', 'StatusService',
    function($scope, $modalInstance, type, ModalService, $security, StatusService) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.uniqueName = true;
            // копирование
            $scope.type = angular.copy(type);

            // Определение заголовка модального окна
            if (type == null || type.id == null) {
                $scope.title = 'Создание нового типа организации';
                $scope.edit = true;
            } else {
                $scope.title = `Редактирование типа организации "${type.name}"`;
                $scope.edit = true;
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.type.status) {
                    $scope.type.status = data._embedded;
                }
            });
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != '') {
                // HazardClassesService.api.exists({
                //     filters: (($scope) => {
                //         let filters = [];
                //         filters.push(`'name' EQ '${scope.type.name}'`);
                //         if ($scope.type.id) {
                //             filters.push(`'id' NE '${scope.type.id}'`);
                //         }
                //         return filters;
                //     })($scope),
                // }, (data) => {
                //     $scope.uniqueName = !data._embedded;
                // });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Success
         */
        function ok() {
            $modalInstance.close($scope.type);
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/src-categories');
        }

        // endregion
    }];
